import React from 'react';
import { Button } from '@components';
import { Card, Form, Row, Col, ButtonGroup } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useLocation, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Get, Put } from '@app/utils/httpProvider';
import { DANHMUCVANBANGCHUNGCHI_API } from '@app/utils/apiUrl';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { messageError, messageToast, status200 } from '../../../../utils/define';
import { URI_INTERNAL } from '../../../../utils/pathLocations';
import HorizontalFieldsRow from '@app/components/common/HorizontalFieldsRow';

const schema = yup.object().shape({
    ten: yup.string().required(messageError.emptyMessage).max(255, 'Tên không được vượt quá 255 ký tự')
});

const DanhMucVanBangChungChiEdit = () => {
    const history = useHistory();
    const queryClient = useQueryClient();
    const location = useLocation();
    const params = new URLSearchParams(location.search.substring(1));
    const itemId = params.get('id');

    const itemQuery = useQuery(['danhMucVanBangChungChi', itemId], () => Get(DANHMUCVANBANGCHUNGCHI_API.GET_ITEM, itemId), {
        enabled: !!itemId
    });

    const editMutation = useMutation((value) => Put(DANHMUCVANBANGCHUNGCHI_API.UPDATE_ITEM, itemId, value));

    const handleEdit = (values) => {
        const model = {
            ...values,
            doiTuongApDung: values.doiTuongApDung ? Number(values.doiTuongApDung) : null
        };

        editMutation.mutate(model, {
            onSuccess: (res) => {
                if (res.status !== status200) {
                    toast.error(messageToast.messageToastUpdateError);
                } else {
                    toast.success(messageToast.messageToastUpdateSuccess);
                    // Cập nhật lại cache data với dữ liệu mới
                    queryClient.setQueryData(['danhMucVanBangChungChi', itemId], { ...itemQuery.data, ...model });
                    history.push(URI_INTERNAL.DANHMUCVANBANGCHUNGCHI_PATH);
                }
            },
            onError: (err) => {
                toast.error(err?.message || 'Đã có lỗi xảy ra, vui lòng thử lại !');
            }
        });
    };

    if (itemQuery.isLoading) {
        return <div>Đang tải....</div>;
    }

    if (itemQuery.isError || !itemQuery.data) {
        return (
            <Card>
                <Card.Body className="text-center py-5">
                    <h5 className="text-danger mb-3">Có lỗi xảy ra hoặc không tìm thấy danh mục văn bằng chứng chỉ</h5>
                    <p className="text-muted mb-4">Bản ghi này có thể đã bị xóa hoặc không tồn tại trên hệ thống.</p>
                    <Button
                        theme="secondary"
                        onClick={() => history.push(URI_INTERNAL.DANHMUCVANBANGCHUNGCHI_PATH)}
                    >
                        Quay lại danh sách
                    </Button>
                </Card.Body>
            </Card>
        );
    }

    const currentData = itemQuery.data;

    return (
        <Card>
            <Card.Header as="h5">Sửa danh mục tên văn bằng chứng chỉ</Card.Header>
            <Card.Body>
                <Formik
                    enableReinitialize
                    validationSchema={schema}
                    onSubmit={(values) => handleEdit(values)}
                    initialValues={{
                        ten: currentData.ten || currentData.Ten || '',
                        doiTuongApDung: currentData.doiTuongApDung || currentData.DoiTuongApDung || 0
                    }}
                >
                    {({ handleSubmit, handleChange, values, errors }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            {/* Trường Tên */}
                            <HorizontalFieldsRow
                                fields={[
                                    {
                                        label: 'Tên',
                                        name: 'ten',
                                        value: values.ten,
                                        onChange: handleChange,
                                        isInvalid: errors.ten,
                                        error: errors.ten
                                    }
                                ]}
                            />

                            {/* Trường Đối tượng áp dụng */}
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label column md={2}>
                                    Đối tượng áp dụng
                                </Form.Label>
                                <Col md={10}>
                                    <Form.Control
                                        as="select"
                                        name="doiTuongApDung"
                                        value={values.doiTuongApDung}
                                        onChange={handleChange}
                                        isInvalid={!!errors.doiTuongApDung}
                                    >
                                        <option value="">-- Chọn đối tượng --</option>
                                        <option value={1}>Bác sĩ</option>
                                        <option value={2}>Điều dưỡng</option>
                                        <option value={3}>Kỹ thuật y</option>
                                        <option value={4}>Hộ sinh</option>
                                        <option value={5}>Y sĩ</option>
                                        <option value={6}>Cử nhân dinh dưỡng lâm sàng</option>
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        {errors.doiTuongApDung}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-3">
                                <Col md={{ span: 10, offset: 2 }}>
                                    <ButtonGroup className="mb-2">
                                        <Button type="submit" theme="primary" disabled={editMutation.isLoading}>
                                            Cập nhật
                                        </Button>
                                        &nbsp;&nbsp;&nbsp;
                                        <Button onClick={() => history.push(URI_INTERNAL.DANHMUCVANBANGCHUNGCHI_PATH)} theme="secondary">
                                            Hủy
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                            </Form.Group>
                        </Form>
                    )}
                </Formik>
            </Card.Body>
        </Card>
    );
};

export default DanhMucVanBangChungChiEdit;